import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  handleNewConversationRequest,
  regenerateResponse,
  setShowSignPopup,
  setUpLoadedFile,
} from "../../../store/one-query/chatsSlice";
import { conversationsActions } from "../../../store/one-query/conversationSlice";
import { useNavigate } from "react-router-dom";
import { StarsIcon } from "../../../Custom-imeges/StarsIcon";
import {useMethodHelper} from "../../../store/one-query/useMethodHelper";

interface PopupProps {
  show: boolean;
  type?: string;
  message?: string; 
  btnTitle:string;
  handleClose: () => void;
  btnAction?: string;
  Method?:()=>void;
}

const SignInPopup: React.FC<PopupProps> = ({
  show,
  type,
  message,
  handleClose,
  btnTitle,
  btnAction,
  Method
}) => {
  const dispatch = useAppDispatch();
  const User = useAppSelector((s) => s.User);
  const executeAction = useMethodHelper();
  const handleAction = () => {
    if(Method){
      Method()
    }
    if(btnAction){
      executeAction(btnAction);
    }
    dispatch(setShowSignPopup({show: false , type: "" , message: "",btnTitle:''}))
  }

  return (
    <Modal className="DeleteModal" show={show} onHide={handleClose} centered style={{zIndex:"10000000"}}>
      <Modal.Header closeButton className="clearConPopupHeader border-0">
        <Modal.Title>
          {type}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`DeleteModalBody border-0 rounded-bottom-4 p-0`}>
        <div className="d-flex flex-column align-items-center">
            <div className="popupSignToSaveText my-4">
              <span className="me-2 ">{message}</span>
              {User.IsAuthenticated && <StarsIcon className="custom-icon"/>}
            </div>
          <div className="line popup"></div>
          <div className="d-flex pb-3 px-4 buttons justify-content-end w-100">
              <button className="cancelDeleteBtn me-2" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="confirmDeleteBtn"
                onClick={handleAction}
              >
              {btnTitle}
              </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SignInPopup;
